import { observable } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment';

export type TransportElementTerminalResponseArgs = {
  id: number;
  name: string;
  time: string;
  time_zone: string;
};

export type TransportElementTerminalArgs = {
  id: number;
  name: string;
  time: Moment;
  timeZone: string;
};

export const convertTransportElementTerminalResponseToArgs = (response: TransportElementTerminalResponseArgs) => {
  const args: TransportElementTerminalArgs = {
    id: response.id,
    name: response.name,
    time: moment(response.time),
    timeZone: response.time_zone
  };
  return args;
};

export default class TransportElementTerminal {
  @observable id: number;
  @observable name: string;
  @observable time: Moment;
  @observable timeZone: string;

  constructor(args: TransportElementTerminalArgs) {
    this.id = args.id;
    this.name = args.name;
    this.time = args.time;
    this.timeZone = args.timeZone;
  }

  get description() {
    const time = this.time.clone();
    return `${this.name || ''} ${time.tz(this.timeZone).format('YYYY/MM/DD HH:mm')}`;
  }

  get foreignAirDescription() {
    const time = this.time.clone();
    return `${time.tz(this.timeZone).format('YYYY/MM/DD HH:mm')} ${this.name}`;
  }

  get timeStr() {
    return `${this.time.tz(this.timeZone).format('HH:mm')}`;
  }
}
